module.exports = __webpack_public_path__ + "static/media/portrait2.8091b44b.jpg";